// =============================================================================
// VulnTracker — App Router
// =============================================================================
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { DashboardPage } from '@/pages/DashboardPage';
import { useAuthStore } from '@/stores/authStore';
import { ProjectsPage } from '@/pages/ProjectsPage';
import { VulnerabilitiesPage } from '@/pages/VulnerabilitiesPage';
import { ComponentsPage } from '@/pages/ComponentsPage';
import { NotificationsPage } from '@/pages/NotificationsPage';
import { OrganizationsPage } from '@/pages/OrganizationsPage';
import { MatchesPage } from '@/pages/MatchesPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { DeveloperPage } from '@/pages/DeveloperPage';
import { AboutPage } from '@/pages/AboutPage';

export default function App() {
  const fetchMe = useAuthStore((s) => s.fetchMe);
  const initFromExternalToken = useAuthStore((s) => s.initFromExternalToken);

  useEffect(() => {
    // 1. Pick up JWT from ?token= URL param or __sm_token cookie (SSO handoff)
    initFromExternalToken();
    // 2. Hydrate user profile from backend
    fetchMe();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        {/* All routes are now public - no authentication required */}
        <Route element={<Layout />}>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/vulnerabilities" element={<VulnerabilitiesPage />} />
          <Route path="/components" element={<ComponentsPage />} />
          <Route path="/matches" element={<MatchesPage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/organizations" element={<OrganizationsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/developer" element={<DeveloperPage />} />
          <Route path="/about" element={<AboutPage />} />
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
